import React from 'react'
import {
  Box,
  Typography
} from '@mui/material';

const StaySuppliersMapping = () => {
  return (
    <>
      <Box className="headingBtnWrap">
        <Typography variant="h1">Suppliers Mapping</Typography>
      </Box>
    </>
  )
}

export default StaySuppliersMapping
